// extracted by mini-css-extract-plugin
module.exports = {"container":"Radio_container__1g17x","radio":"Radio_radio__2iCo_"};